// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"680a00c2","453":"a444f289","667":"7b475997","977":"74c70602"}[chunkId] + ".chunk.js";
};